const highlightFunc = (text, indexString) => {
  const regex = new RegExp(`^${indexString}`, 'i');
  const innerText = text.replace(regex, (found) => `<strong class="black--text">${found}</strong>`);
  return innerText;
};
export default {
  bind(el, binding) {
    const { text, indexString } = binding.value;
    // eslint-disable-next-line no-param-reassign
    el.innerHTML = highlightFunc(text, indexString);
  },
  update(el, binding) {
    const { text, indexString } = binding.value;
    // eslint-disable-next-line no-param-reassign
    el.innerHTML = highlightFunc(text, indexString);
  },
};
